import { Injectable } from '@angular/core';
import { HttpService } from './HttpService';
import { Observable } from 'rxjs';
import { IProject } from '../models/IProject';
import { IReportUser } from '../models/IReportUser';
import { IReport, IEmployeeReport } from '../models/IReport';
import { IBlobResult } from '../models/IBlobResult';
import {ISummaryReport, ISummaryReportDetails} from "../models/ISummaryReport";



@Injectable()
export class ReportingService {
    constructor(private http: HttpService) { }

    exportToExcel(start: string, end: string, projects: string): Observable<IBlobResult> {
        return this.http.export(`assets/export-reports?startDate=${start}&endDate=${end}${projects}`);
    }

    getUsersTotalReports(periodFrom: string, periodTo: string): Observable<IReportUser> {
        return this.http.get<IReportUser>(`report/employees?startDate=${periodFrom}&endDate=${periodTo}`);
    }

    getAllProjects(): Observable<IProject[]> {
        return this.http.get<IProject[]>(`report/projects`);
    }

    getUserReportsAdmin(userId: number, periodFrom: string, periodTo: string): Observable<IEmployeeReport> {
        return this.http.get<IEmployeeReport>(`report/detail?employeeId=${userId}&startDate=${periodFrom}&endDate=${periodTo}`);
    }

    getUserReports(periodFrom: string, periodTo: string): Observable<IReportUser> {
        return this.http.get<IReportUser>(`report?startDate=${periodFrom}&endDate=${periodTo}`);
    }

    deleteReport(reportId: number): Observable<void> {
        return this.http.delete(`report?id=${reportId}`);
    }

    addUserReportAdmin(employeeId: number, model: IReport): Observable<void> {
        return this.http.post(`report/add?employeeId=${employeeId}`, model);
    }

    addUserReport(model: IReport): Observable<void> {
        return this.http.post(`report/add/employee`, model);
    }

    updateReport(model: IReport): Observable<void> {
        return this.http.put(`report`, model);
    }

    getUserProjects(employeeId?: number): Observable<IProject[]> {
        let url = `report/projects/profile`;
        if (employeeId != null) {
            url = `report/projects/profile?employeeId=${employeeId}`;
        }
        return this.http.get(url);
    }

    getUserDefaultProject(employeeId?: number): Observable<IProject> {
        let url = `report/defaultprojects`;
        if (employeeId != null) {
            url = `report/defaultprojects?employeeId=${employeeId}`;
        }
        return this.http.get<IProject>(url);
    }

    setDefaultProject(projectId: number, userId?: number): Observable<void> {
        return this.http.post(`report/projects?projectId=${projectId}` + (!!userId ? '&employeeId=' + userId : ''), null);
    }

    exportSummaryReport(start: string, end: string): Observable<IBlobResult> {
      return this.http.export(`money-report/summary/export?from=${start}&to=${end}`);
    }

    getSummaryReport(from: string, to: string): Observable<ISummaryReport> {
      return this.http.get<ISummaryReport>(`money-report/summary?from=${from}&to=${to}`);
    }

    getSummaryTotalDetails(start: string, end: string, category: string): Observable<ISummaryReportDetails[]> {
      return this.http.get(`money-report/summary/details?from=${start}&to=${end}&category=${category}`);
    }
}
